import { render, staticRenderFns } from "./TableForRequesthistory.vue?vue&type=template&id=2239339d&scoped=true"
import script from "./TableForRequesthistory.vue?vue&type=script&lang=js"
export * from "./TableForRequesthistory.vue?vue&type=script&lang=js"
import style0 from "./TableForRequesthistory.vue?vue&type=style&index=0&id=2239339d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2239339d",
  null
  
)

export default component.exports